import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-207b6c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setup-user" }
const _hoisted_2 = { class: "content rel" }
const _hoisted_3 = { class: "ml_10" }
const _hoisted_4 = { class: "flex-cen-ter" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mr_10 btn" }
const _hoisted_7 = { class: "ml_10" }
const _hoisted_8 = { class: "flex-cen-ter" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mr_10 btn" }
const _hoisted_11 = { class: "text-rt" }
const _hoisted_12 = { class: "tripartite-platforms" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "platforms" }
const _hoisted_15 = { class: "flex-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "platform-text" }
const _hoisted_18 = { class: "binded" }
const _hoisted_19 = { class: "flex-center" }
const _hoisted_20 = { class: "bind" }
const _hoisted_21 = ["onClick"]

import {
  ref,
  reactive,
  computed,
  onMounted
} from 'vue'

import { Check, Select, InfoFilled } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import SwitchRam from './components/SwitchRam.vue'
import countryCodes from '@/views/signup/components/countryCodes'
import { editInfo as createRules } from '@/views/signup/components/rules'
import { useLoading } from '@/views/signup/components/utils'
import {
  updateUser,
  cancelSubUser,
  cancelUser,
  getBindList,
  cancelBind,
  third,
  BindListItem
} from '@/apis/login'
import CommonDialog from '@/components/common/CommonDialog.vue'
import ChangeEmail from './components/ChangeEmail.vue'
import ChangePhone from './components/ChangePhone.vue'
import useEdited from '@/util/useEdited'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import PendingEventDialog from './components/PendingEventDialog.vue'
import WithdrawDialog from './components/WithdrawDialog.vue'
import router from '@/router'
import { isJA } from '@/store'
import { Plat, compTripartitePlatforms } from '@/common/const'
import { AuthResponse, UserInfo, openAuth2 } from '@/plugins/tripartite-login'

interface BindItem extends BindListItem {
  key: Plat
  logoUrl: string
  thirdCustomerName: string
  isBind: boolean
  thirdCustomerId: string
  country: string[]
}


export default /*#__PURE__*/_defineComponent({
  props: ['customer', 'accounts', 'account'],
  emits: ['update', 'update:account'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()



const user = computed(() => store.getters.user)

const editIcon = require('@/assets/image/icon/floatrate/edit.png')

const switchRamUpdate = (e: any) => {
  emit('update:account', e)
}
const visible = ref(false)
const visibleChangePhone = ref(false)

const tripartiteLogins = ref<BindItem[]>()
// 注销时待处理事件对话框对象
const pendingEventObj = reactive({
  show: false
})

// 提现对话框对象
const withdrawDialogObj = reactive({
  show: false,
  platType: '',
  shopInfo: {}
})

const texts = [
  '用户名',
  '联系人姓名',
  '密码',
  '再次确认密码',
  '性别',
  '邮箱',
  '验证码',
  '联系电话',
  '默认业务类型'
]

const tips = [
  '请设置用户名',
  '你的名字是？',
  '设置你的登陆密码',
  '请再次输入您的密码',
  '性别',
  '输入邮箱',
  '输入验证码',
  '请输入您的手机号码（选填）',
  '请输入你的Chatwork ID （选填）',
  '请输入你的Skype （选填）'
]

const [loading, api] = useLoading(updateUser)
const [loading2, cancelApi] = useLoading(cancelSubUser)

const origin = Object.assign(
  {},
  {
    ...props.customer,
    countryCode: props.customer.countryCode || '-'
  }
)

const customerEmail = ref(origin.customerEmail)

const formRef = ref()

const [form, update, clear] = useEdited(origin, () => {
  const f = formRef.value
  f.validate((valid: boolean) => {
    if (valid) {
      if (form.accountType === 1) {
        delete form.customerId
      }
      api({
        ...form,
        countryCode: form.countryCode === '-' ? '' : form.countryCode
      }).then((res) => {
        if (res.success) {
          ElMessage.success(t('用户信息更新成功'))
          clear()
          if (form.accountType === 1) {
            store.dispatch('route/updateUser')
          } else {
            emit('update')
          }
        }
      })
    }
  })
})

const disabled = ref(false)
const rules = createRules(form, disabled)
// rules.customerName.push({ required: true, message: t('联系人姓名不能为空'), trigger: 'blur' })

// todo:注销账号
const logOff = () => {
  // confirmLogoff(
  //   () => cancelApi(),
  //   () => {}
  // )
  pendingEventObj.show = true
}

// 注销时待处理事件对话框关闭回调
const pendingEventClose = (obj?: any) => {
  pendingEventObj.show = false
  if (obj) {
    if (obj.key === 'withdrawal') {
      withdrawDialogObj.platType = obj.value
      withdrawDialogObj.show = true
      // 店铺信息
      withdrawDialogObj.shopInfo = obj.shopInfo
    }
    if (obj.key === 'logoff') {
      const formData = {
        customerId: user.value.customerId
      }
      const api = user.value.accountType === 2 ? cancelSubUser : cancelUser
      api(formData).then((res: any) => {
        if (res.code === '0') {
          router.replace('/')
          store.dispatch('route/changeToken', null)
        }
      })
    }
  }
}

// 提现对话框关闭回调
const withdrawClose = () => {
  withdrawDialogObj.platType = ''
  withdrawDialogObj.show = false
}

const fetchBindList = async () => {
  const list = await getBindList() // 只返回已绑定的list
  if (list.success) {
    tripartiteLogins.value = compTripartitePlatforms.value.map<BindItem>((item: any) => {
      const bind = list.data?.find((bind) => bind.thirdPlatform === item.key)
      return {
        ...item,
        thirdCustomerName: bind?.thirdCustomerName,
        isBind: !!bind,
        thirdCustomerId: bind?.thirdCustomerId,
        ...bind
      }
    })
  }
}

const unBind = async (thirdPlatform: string, thirdCustomerId?: string) => {
  try {
    const res = await cancelBind({
      thirdPlatform,
      thirdCustomerId
    })
    if (res.success) {
      ElMessage.success(t('解绑成功'))
      fetchBindList()
    } else {
    }
  } catch (error) {
  }
}

const authCallback = async (rsp: AuthResponse<UserInfo>) => {
  try {
    const res = await third({
      customerId: user.value.customerId as number,
      thirdCustomerId: rsp.userInfo?.thirdCustomerId as string,
      thirdPlatform: rsp.userInfo?.thirdPlatform as Plat
    })

    if (res.success) {
      ElMessage.success(t('绑定成功'))
      fetchBindList()
    } else {
    }
  } catch (error) {
  }
}

const bind = (plat: Plat) => {
  // 若用户已经授权过某个平台,store中的值等于当前点击的平台，则直接登录
  openAuth2({ plat }, authCallback)
}

onMounted(() => {
  fetchBindList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _directive_main = _resolveDirective("main")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        model: _unref(form),
        rules: _unref(rules),
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('切换账号')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SwitchRam, {
                account: __props.account,
                accounts: __props.accounts,
                onUpdate: switchRamUpdate,
                style: {"width":"450px"}
              }, null, 8, ["account", "accounts"]), [
                [_directive_main]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)(texts[0]),
            prop: "loginName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _unref(form).loginName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).loginName) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[0]),
                maxlength: 18
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "customerName",
            label: _unref(t)(texts[1])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _unref(form).customerName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).customerName) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[1]),
                maxlength: 18
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)(texts[5])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "gary-block flex-bwn-ter cursor-pt",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (visible.value = true))
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(customerEmail.value), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _unref(editIcon),
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _withDirectives(_createElementVNode("label", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_unref(t)('修改')), 1)
                  ], 512), [
                    [_directive_main]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "customerMobile",
            label: _unref(t)(texts[7])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "gary-block flex-bwn-ter cursor-pt",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (visibleChangePhone.value = true))
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(form).countryCode + ' ' + (_unref(form).customerMobile ?? '')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: _unref(editIcon),
                    alt: ""
                  }, null, 8, _hoisted_9),
                  _withDirectives(_createElementVNode("label", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_unref(t)('修改')), 1)
                  ], 512), [
                    [_directive_main]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(isJA)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: "corpName",
                label: _unref(t)('公司名称')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).corpName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).corpName) = $event)),
                    modelModifiers: { trim: true }
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                prop: "chatWorkId",
                label: "Chatwork ID"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).chatWorkId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).chatWorkId) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(t)(tips[8]),
                    maxlength: 30
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", _hoisted_11, [
        (_unref(store).getters.editing)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              disabled: disabled.value,
              type: "primary",
              loading: _unref(loading),
              onClick: _unref(update)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider, { style: {"margin-bottom":"30px"} }),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('三方登录管理')), 1),
        _createElementVNode("ul", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tripartiteLogins.value, (paltform) => {
            return (_openBlock(), _createElementBlock("li", {
              key: paltform.key,
              class: "platform"
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: paltform.logoUrl,
                  alt: "logo",
                  style: {"margin-right":"8px"},
                  width: "28",
                  height: "28"
                }, null, 8, _hoisted_16),
                _createElementVNode("span", _hoisted_17, _toDisplayString(paltform.key), 1),
                _withDirectives(_createElementVNode("span", _hoisted_18, [
                  _createVNode(_component_el_icon, {
                    size: 10,
                    color: "#fff"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Select))
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, paltform.isBind]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString(paltform?.thirdEmail || paltform?.thirdPhoneNumber || paltform.thirdCustomerName ||
                paltform.thirdCustomerId), 1),
                (paltform.isBind)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 0,
                      "popper-class": "confirm-bind",
                      "confirm-button-text": "Yes",
                      "cancel-button-text": "No",
                      icon: _unref(InfoFilled),
                      "icon-color": "#626AEF",
                      title: _unref(t)('是否解绑{A}账户', { A: paltform.key }),
                      onConfirm: ($event: any) => (unBind(paltform.key, paltform.thirdCustomerId))
                    }, {
                      reference: _withCtx(() => [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('解除')), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon", "title", "onConfirm"]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "bind",
                      onClick: ($event: any) => (bind(paltform.key))
                    }, _toDisplayString(_unref(t)('绑定1')), 9, _hoisted_21))
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(CommonDialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
      width: "540px",
      top: "25vh",
      title: _unref(t)('修改邮箱'),
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (visible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(ChangeEmail, {
          customer: __props.customer,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (visible.value = false)),
          onUpdate: _cache[7] || (_cache[7] = (v) => (customerEmail.value = v))
        }, null, 8, ["customer"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CommonDialog, {
      visible: visibleChangePhone.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((visibleChangePhone).value = $event)),
      width: "540px",
      top: "25vh",
      title: _unref(t)('修改手机号'),
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (visibleChangePhone.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(ChangePhone, {
          customer: __props.customer,
          onCancel: _cache[10] || (_cache[10] = ($event: any) => (visibleChangePhone.value = false)),
          onUpdate: _cache[11] || (_cache[11] = (v, countryCode) => { _unref(form).customerMobile = v; _unref(form).countryCode = countryCode })
        }, null, 8, ["customer"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    (_unref(pendingEventObj).show)
      ? (_openBlock(), _createBlock(PendingEventDialog, {
          key: 0,
          onClose: pendingEventClose
        }))
      : _createCommentVNode("", true),
    (_unref(withdrawDialogObj).show)
      ? (_openBlock(), _createBlock(WithdrawDialog, {
          key: 1,
          platType: _unref(withdrawDialogObj).platType,
          shopInfo: _unref(withdrawDialogObj).shopInfo,
          onClose: withdrawClose
        }, null, 8, ["platType", "shopInfo"]))
      : _createCommentVNode("", true)
  ]))
}
}

})